import styled from 'styled-components';
import { ColorMixin } from '../../../styles/global';

export const WorksSectionContainer = styled.div`
  padding: 50px 0 20px;

  .title {
    font-size: 32px;
    margin-bottom: 20px;
  }

  .text {
    font-size: 16px;
  }

  @media screen and (min-width: 1025px) {
    padding: 0 0 100px;

    .title {
      font-size: 44px;
      margin-bottom: 30px;
    }

    .text {
      font-size: 22px;
    }
  }
`;

export const ProjectsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px 0 70px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);

  &:last-of-type {
    border-bottom: none;
    padding: 50px 0 0;
  }

  @media screen and (min-width: 1025px) {
    padding: 50px 0 70px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }
`;

export const ProjectInfo = styled.div`
  width: 100%;

  a {
    .title {
      &:hover {
        color: ${ColorMixin?.active};
      }
    }
  }

  .title {
    margin-bottom: 18px;
    text-align: center;
    margin-bottom: 18px;
    font-size: 30px;
    text-decoration: underline;
    filter: drop-shadow(1px 4px 10px rgba(200, 200, 200, 0.5));
    color: white;
    font-weight: 600;
  }

  .text2 {
    font-size: 20px;
    margin-top: 25px;
  }

  .techs {
    img {
      width: 50px;
      height: 50px;
      margin-right: 15px;
      background-color: white;
      border-radius: 5px;
      padding: 5px;

      &:hover {
        filter: grayscale(100%);
        transition: 700ms all;
        transform: scaleY(100%);
      }
    }
  }

  .title {
    font-size: 30px;
    text-decoration: underline;
    filter: drop-shadow(1px 4px 10px rgba(200, 200, 200, 0.5));
    color: white;
    font-weight: 700;
  }

  a:hover {
    color: ${ColorMixin?.active};

  }

  .code-link {
    color: white;
    text-decoration: underline;
    font-size: 20px;
    padding-top: 10px;
    display: block;

    &:hover {
      color: ${ColorMixin?.active};
    }
  }

  @media screen and (min-width: 1025px) {
    width: 50%;

    .title {
      text-align: left;
    }
  }
`;

export const ProjectMedias = styled.div`
  width: 100%;
  padding: 50px 18px;

  .slick-dots li button:before {
    color: white;
  }

  .SliderProject {
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    button {
      width: 35px;
      height: 35px;
    }
  }

  .slick-next:before,
  .slick-prev:before {
    color: ${ColorMixin?.active};
    font-size: 35px;
  }

  .slick {
    &-prev {
      left: -40px;
    }
    &-next {
      right: -40px;
    }
  }

  @media screen and (min-width: 1025px) {
    width: 50%;
    padding: 0 50px;

    .SliderProject {
      img {
        max-height: 475px;
      }
    }
  }
`;
